export function inferTeachingRole(userProfile) {
  const explicit = String(userProfile?.teaching_role || userProfile?.teachingRole || '').trim().toLowerCase();
  if (explicit === 'curricolare') return 'curricolare';
  if (explicit === 'sostegno') return 'sostegno';

  const role = String(userProfile?.role || '').trim().toLowerCase();
  if (role.includes('curricolare')) return 'curricolare';
  if (role.includes('sostegno')) return 'sostegno';

  const ruolo = String(userProfile?.ruolo || '').trim().toLowerCase();
  if (ruolo.includes('curricolare')) return 'curricolare';
  if (ruolo.includes('sostegno')) return 'sostegno';

  return 'sostegno';
}

export function inferPreferredContext(userProfile) {
  const teachingRole = inferTeachingRole(userProfile);
  return teachingRole === 'curricolare' ? 'class' : 'student';
}
